import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const GitPullRequest = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => {
    return (
      <Icon ref={ref} {...props}>
        <circle cx="18" cy="18" r="3" />
        <circle cx="6" cy="6" r="3" />
        <path d="M13 6h3a2 2 0 0 1 2 2v7M6 9v12" />
      </Icon>
    );
  },
);

GitPullRequest.displayName = "GitPullRequest";
